import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MpThemeService {
  constructor() {}
  private _themes: ReadonlyArray<string> = [
    'marketplace', // FortressGB
    'mp-unique-code', // Unique Code
    'mp-download', // Download
    'mp-event', // Event
    'mp-product', // Product
    'mp-virtual-event', // Virtual event
  ];

  getTheme(id: number): string {
    let theme = 'marketplace';
    if (id > -1 && id < this._themes.length) {
      theme = this._themes[id];
    }
    return theme;
  }
}
